import { render, staticRenderFns } from "./ModalFormDeleteAforo.vue?vue&type=template&id=5ae7fb16"
import script from "./ModalFormDeleteAforo.vue?vue&type=script&lang=js"
export * from "./ModalFormDeleteAforo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports